import type { IAvailability } from "@app/availability/types";
import type { ICart, IGuestDetails } from "@app/booking/types";
import { differenceInDays } from "date-fns";

import { IBookingEngineState } from "../../types";

export const ibeStateToTrackingSystemBooking = (
    state: IBookingEngineState,
    availability: IAvailability[],
    gd: IGuestDetails | null,
    cart: ICart | null
) => {
    // Ensure the ibe state is valid
    if (!state.bookingState?.bookings?.length || !state.bookingState?.dates || !availability.length) {
        return null;
    }

    const arrivalDate = new Date(state.bookingState.dates.fromDate);
    const departureDate = new Date(state.bookingState.dates.toDate);
    // const babyCount = (state.bookingState?.bookings || []).reduce((sum, b) => sum + b.infantCount, 0);
    const minRoomRate = availability[0].rooms.reduce((min, el) => (el.min_rate <= min ? el.min_rate : min), Infinity);
    const maxRoomRate = availability[0].rooms.reduce((max, el) => (el.max_rate >= max ? el.max_rate : max), 0);
    const avgRoomRate = (minRoomRate + maxRoomRate) / 2;

    const [totalAdultCountForAllRooms, totalChildCountForAllRooms, totalBabyCountForAllRooms] = (state.bookingState.bookings || []).reduce(
        ([currentTotalAdultCount, currentTotalChildCount, currentTotalBabyCount], booking) => {
            const bookingTotalChildCount = Object.values(booking.childCount).reduce((sum, count) => sum + count, 0);

            return [
                currentTotalAdultCount + booking.adultsCount,
                currentTotalChildCount + bookingTotalChildCount, // Sum of all child categories
                currentTotalBabyCount + (booking.childCount["1"] || 0), // Assuming category 1 is for infants/babies
            ];
        },
        [0, 0, 0]
    );

    return {
        arrivalDate,
        departureDate,
        adultCount: totalAdultCountForAllRooms,
        childCount: totalChildCountForAllRooms,
        babyCount: totalBabyCountForAllRooms,
        stayNights: differenceInDays(new Date(departureDate), new Date(arrivalDate)),
        currencyCode: state.currency,
        roomCount: state.bookingState.bookings.length,
        rateValues: {
            min: minRoomRate,
            avg: avgRoomRate,
            max: maxRoomRate,
        },
        roomsRates: availability[0].rooms.map((room) => ({
            title: room.name,
            rates: room.rates.map((r) => ({ title: r.name, rate: r.rate })),
        })),
        bookingPrice: Number(cart?.total) || null,
        promoCode: state.promoCode,
        email: gd?.email || null,
        languageCode: state.language,
        roomType: state.bookingState.bookings[0].room?.name || null,
        roomRateType: state.bookingState.bookings[0].rate?.name || null,
        upsellProducts: state.bookingState.bookings[0].extras.map((ex) => ex.name),
        isRoomAvailability: true,
    };
};
